import { HIDE_MODAL_V2, SHOW_MODAL_V2 } from 'redux/actions/types';
import type { ModalState } from 'ts/types/modal.types';
import { noop } from 'utils/global-utils';

const defaultState: ModalState = {
  content: undefined,
  onClose: noop,
  show: false,
  showCloseIcon: true,
};

function modalReducer(state = defaultState, action: any) {
  switch (action.type) {
    case SHOW_MODAL_V2:
      return {
        ...state,
        showCloseIcon: true,
        onClose: noop,
        ...action.payload,
        show: true,
      };
    case HIDE_MODAL_V2:
      return { ...state, show: false };
    default:
      return state;
  }
}

export default modalReducer;
